import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { ErrorInfo } from '../../api/model';

interface Props {
  error: AxiosError<ErrorInfo> | null;
}

/**
 * エラー表示用コンポーネント
 * @param param0
 * @returns
 */
function ErrorComponent({ error }: Props) {
  const { t } = useTranslation();

  return (
    <>
      <div>{t('エラーが発生しました。')}</div>
      <div className="mt10">
        <p>■{t('ステータス')}</p>
        <p className="mt5">
          <span>{error?.response?.status ?? t('不明')}</span>
          <span className="ml10">{error?.response?.statusText}</span>
        </p>
      </div>
      <div className="mt10">
        <p>■{t('エラーコード')}</p>
        <p className="mt5">{error?.response?.data.error_code ?? error?.code ?? t('不明')}</p>
      </div>
      <div className="mt10">
        <p>■{t('エラーメッセージ')}</p>
        <p className="mt5">{error?.response?.data.message ?? error?.message ?? t('不明なエラー')}</p>
      </div>
      <div className="mt10">
        <p>■{t('詳細情報')}</p>
        <p className="mt5">{error?.response?.data.debug_info ?? t('特になし')}</p>
      </div>
    </>
  );
}

export default ErrorComponent;
